import { admin2 } from './instance'

export const GetShopBusinessTimeConfig = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/shopBusinessTime`,
  })
}

export const UpdateShopBusinessTimeConfig = async ({
  shopId,
  mode,
  customWeekConfigs,
  allExcludeTimeRules,
  shopExcludeTimeRules,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/shopBusinessTime`,
    data: {
      mode,
      customWeekConfigs,
      allExcludeTimeRules,
      shopExcludeTimeRules,
    },
  })
}
